import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getUnixTimeDateUtil } from 'packages/src'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import { REDUX_SORT_ORDER } from '../../../constants/should-sort'
import sortByArrayUtil from 'packages/src/modules/array/sort-by'

/**
 * Gets the ordered instances.
 *
 * @private
 *
 * @param   {Object} data
 *          {Instance[]} instances
 *          {strings[]} sortKeys
 * @returns {Instance[]}
 */
export default function getSortedInstancesReduxUtil (data) {
  const {
    instances,
    sortKeys,
    sortOrder = REDUX_SORT_ORDER.DESC
  } = data

  return sortByArrayUtil(instances, instance => {
    const sortKey = sortKeys.find(sortKey => getValueReduxUtil(instance, sortKey) != null)
    let value = sortKeys.length && sortKey ? getValueReduxUtil(instance, sortKey) : getIdReduxUtil(instance)
    const isDate = sortKey && sortKey.endsWith('At')

    if (isDate && value) {
      value = getUnixTimeDateUtil(new Date(value))
    } else if (typeof value === 'string') {
      value = value.toLowerCase()
    }

    if (value < 0) {
      return value
    }

    if (sortOrder === REDUX_SORT_ORDER.ASC) {
      return value
    }
    return -1 * value
  })
}
